import { jsx as _jsx } from "react/jsx-runtime";
import { useNavigate } from 'react-router';
import { Button } from '@mui/material';
import { useStore } from '@mcn-platform/models';
import { applyThemeColor } from '@mcn-platform/converse-lib';
import linkNavigator from '../../portal/common/linkNavigator';
const ButtonWidget = ({ label, link, textColor, buttonColor, outlineColor, borderRadius, hoverColor, editData, font, limitToPageWidth, }) => {
    const navigate = useNavigate();
    const { currentPortal } = useStore();
    const handleClick = (ev) => {
        linkNavigator(link, editData ? (l) => editData.preNavigationHook(l, ev) : navigate);
    };
    const getFontStyle = () => {
        if (!font) {
            return {};
        }
        const o = {};
        if (font.fontFormat.includes('bold')) {
            o.fontWeight = 'bold';
        }
        if (font.fontFormat.includes('italic')) {
            o.fontStyle = 'italic';
        }
        if (font.fontFormat.includes('underline')) {
            o.textDecoration = 'underline';
        }
        return o;
    };
    return (_jsx(Button, { onClick: handleClick, disabled: !link || link.type === 'none', sx: {
            color: applyThemeColor(currentPortal?.stylesheet, textColor),
            backgroundColor: applyThemeColor(currentPortal?.stylesheet, buttonColor),
            outlineColor,
            outlineWidth: 1,
            outlineStyle: 'solid',
            borderRadius: `${borderRadius}px`,
            '&:hover': {
                backgroundColor: applyThemeColor(currentPortal?.stylesheet, hoverColor),
                color: applyThemeColor(currentPortal?.stylesheet, textColor),
            },
            fontSize: font ? `${font.fontSize}px` : undefined,
            fontFamily: font ? font.fontFamily : undefined,
            textTransform: font ? font.textTransform : undefined,
            ...getFontStyle(),
            ...(limitToPageWidth && {
                maxWidth: 1200,
                marginX: 'auto',
                width: '100%',
            }),
        }, children: label }));
};
ButtonWidget.meta = {
    group: 'design',
    name: 'Button',
    sort: 50,
    description: 'Button that can link to a page or action.',
    props: [
        {
            key: 'label',
            name: 'Button Text',
            type: 'text',
            description: 'Text to display in button.',
        },
        {
            key: 'link',
            name: 'Link To',
            type: 'link',
            description: 'Link to go to when button clicked.',
        },
        {
            key: 'limitToPageWidth',
            name: 'Limit Width',
            type: 'boolean',
            description: 'Limit the width of the stack to the maximum page width',
            group: 'style',
        },
        {
            key: 'font',
            name: 'Font',
            type: 'font',
            description: 'Font properties such as Family, size, style.',
            group: 'style',
        },
        {
            key: 'textColor',
            name: 'Text Color',
            type: 'color',
            description: 'Color of text on button.',
            group: 'style',
        },
        {
            key: 'buttonColor',
            name: 'Button Color',
            type: 'color',
            description: 'Link to go to when button clicked.',
            group: 'style',
        },
        {
            key: 'outlineColor',
            name: 'Outline Color',
            type: 'color',
            description: 'Color of the outline around the button.',
            group: 'style',
        },
        {
            key: 'hoverColor',
            name: 'Hover Color',
            type: 'color',
            description: 'Color of the outline around the button.',
            group: 'style',
        },
        {
            key: 'borderRadius',
            name: 'Border Radius',
            type: 'number',
            min: 0,
            max: 50,
            description: 'Radius of the border of the button.',
            group: 'style',
        },
        {
            key: 'layout',
            name: 'Layout',
            type: 'layout',
            description: 'Layout properties such as spacing and background color.',
            group: 'style',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'Button',
        props: {
            label: 'Button',
            textColor: '#000000',
            buttonColor: '#4A90E2',
            outlineColor: '#FFFFFF',
            borderRadius: 4,
            hoverColor: '#336699',
            limitToPageWidth: true,
            link: {
                type: 'none',
            },
            font: {
                fontFamily: null,
                fontSize: '14px',
                fontFormat: [],
            },
        },
    },
};
export default ButtonWidget;
//# sourceMappingURL=ButtonWidget.js.map